class FeaturedInSlider extends HTMLElement {
  constructor() {
    super();
    this._raf = null;
    this._offset = 0;
    this._lastTs = 0;
    this._paused = false;
    this._loopWidth = 0;
  }

  connectedCallback() {
    this.scroller = this.querySelector('[data-cm-fi-scroller]');
    this.tracks = this.querySelectorAll('[data-cm-fi-track]');
    this.root = this.closest('.cm-featured-in') || this;

    if (!this.scroller || this.tracks.length === 0) return;

    this.direction = this.root.dataset.cmFiScrollDirection === 'right' ? 1 : -1;
    this.pauseOnHover = this.root.dataset.cmFiPauseOnHover === 'true';

    const speedSec = this._readSpeedSeconds();
    this._speedSec = speedSec > 0 ? speedSec : 60;

    this._prefersReducedMotion =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.pauseOnHover) {
      this.scroller.addEventListener('mouseenter', () => (this._paused = true));
      this.scroller.addEventListener('mouseleave', () => (this._paused = false));
    }
    this.scroller.addEventListener('focusin', () => (this._paused = true));
    this.scroller.addEventListener('focusout', () => (this._paused = false));

    this._onResize = () => this._measure();
    window.addEventListener('resize', this._onResize, { passive: true });

    this._measure();

    this.scroller.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => this._measure(), { once: true });
    });

    if (!this._prefersReducedMotion) {
      this._start();
    } else {
      this._apply();
    }
  }

  disconnectedCallback() {
    if (this._raf) cancelAnimationFrame(this._raf);
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }

  _readSpeedSeconds() {
    const raw = getComputedStyle(this.root).getPropertyValue('--cm-fi-speed').trim();
    if (!raw) return 0;
    const num = parseFloat(raw);
    if (Number.isNaN(num)) return 0;
    return raw.endsWith('ms') ? num / 1000 : num;
  }

  _measure() {
    const firstTrack = this.tracks[0];
    if (!firstTrack) return;
    const trackWidth = firstTrack.getBoundingClientRect().width;
    const gap =
      parseFloat(getComputedStyle(this.scroller).columnGap || getComputedStyle(this.scroller).gap || '0') || 0;
    this._loopWidth = trackWidth + gap;
    this._wrap();
    this._apply();
  }

  _start() {
    const tick = (ts) => {
      if (!this._lastTs) this._lastTs = ts;
      const dt = (ts - this._lastTs) / 1000;
      this._lastTs = ts;

      if (!this._paused && this._loopWidth > 0 && this._speedSec > 0) {
        const pxPerSec = this._loopWidth / this._speedSec;
        this._offset += this.direction * pxPerSec * dt;
        this._wrap();
        this._apply();
      }

      this._raf = requestAnimationFrame(tick);
    };
    this._raf = requestAnimationFrame(tick);
  }

  _wrap() {
    if (this._loopWidth <= 0) return;
    if (this._offset <= -this._loopWidth) {
      this._offset += this._loopWidth;
    } else if (this._offset >= this._loopWidth) {
      this._offset -= this._loopWidth;
    }
  }

  _apply() {
    this.scroller.style.setProperty('--cm-fi-translate-x', `${this._offset}px`);
  }
}

if (!customElements.get('featured-in-slider')) {
  customElements.define('featured-in-slider', FeaturedInSlider);
}
